import React from "react";

const Loader = () => {
  let loaderClassName = (localStorage.getItem('site_type') === 'Accutrain' || window.location.href.includes('accuedconnect')) ? "greenloader" : "loader";
  return (
    <div className={`mx-auto mt-5 ${loaderClassName}`} />
  );
}
export default Loader;
